<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'approvals/',
    }"
  >
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="کاربر درخواست‌دهنده"
        width="100"
      >
        <template slot-scope="scope">
          <div data-title="کاربر درخواست‌دهنده">
            {{ scope.row.requester.username }}
          </div>
        </template>
      </el-table-column>

      <el-table-column align="center" label="نوع" width="120">
        <template slot-scope="scope">
          <div data-title="نوع">
            {{ getTypeLabel(scope.row.content_type) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="وضعیت تایید"
        width="150"
      >
        <template slot-scope="scope">
          <div data-title="وضعیت تایید">
            <el-select
              class="w-40__select"
              :value="scope.row.approved"
              @change="(value) => updateApprovalStatus(scope.row.id, value)"
              placeholder="انتخاب کنید"
              size="small"
            >
              <el-option label="در انتظار" :value="null"></el-option>
              <el-option label="تایید شده" :value="true"></el-option>
              <el-option label="رد شده" :value="false"></el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        label="عملیات"
        width="140"
      >
        <template slot-scope="scope">
          <div data-title="عملیات">
            <el-button
              v-if="scope.row.content_type.app_label === 'services'"
              @click="showServiceDetails(scope.row.object_id)"
              type="text"
              size="small"
            >
              مشاهده جزئیات
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Service Details Modal -->
    <el-dialog
      title="جزئیات سرویس"
      :visible.sync="serviceModalVisible"
      width="500px"
    >
      <div v-if="serviceDetails" class="service-details">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="detail-item">
            <label>{{ $t('VEHICLE_TITLE') }}:</label>
            <LicensePlate
              :vehicle="serviceDetails.company_vehicle.vehicle"
              :license_plate="serviceDetails.company_vehicle.license_plate"
              :chars="alphaList"
            />
          </div>
          <div class="detail-item">
            <label>{{ $t('SERVICE') }}:</label>
            <p>{{ serviceDetails.service.fa_title }}</p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
          <div class="detail-item">
            <label>{{ $t('DATE') }}:</label>
            <p>{{ formatDate(serviceDetails.date) }}</p>
          </div>
          <div class="detail-item">
            <label>{{ $t('PRICE') }}:</label>
            <p>{{ formatPrice(serviceDetails.price) }}</p>
          </div>
        </div>

        <div v-if="serviceDetails.description" class="mt-6">
          <div class="detail-item">
            <label>{{ $t('DESCRIPTION') }}:</label>
            <p>{{ serviceDetails.description }}</p>
          </div>
        </div>

        <div
          v-if="
            serviceDetails.attachments && serviceDetails.attachments.length > 0
          "
          class="mt-6"
        >
          <div class="detail-item">
            <label>پیوست‌ها:</label>
            <div class="flex flex-wrap gap-2 mt-2">
              <el-button
                v-for="(attachment, index) in serviceDetails.attachments"
                :key="attachment.id"
                @click="downloadAttachment(attachment.id)"
                :loading="downloadingAttachments[attachment.id]"
                type="primary"
                size="small"
              >
                {{ attachment.title || `پیوست ${index + 1}` }}
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="serviceLoading" class="text-center py-8">
        <div class="inline-flex items-center">
          <div
            class="
              animate-spin
              rounded-full
              h-6
              w-6
              border-b-2 border-blue-600
              mr-3
            "
          ></div>
          <span class="text-gray-600">{{ $t('LOADING') }}</span>
        </div>
      </div>
    </el-dialog>
  </Content>
</template>

<script>
import { getApprovals, updateApproval } from '@/api/approvals'
import { getAService } from '@/api/services'
import { licenseChars } from '@/api/global'
import { axiosFactory } from '@/configs/axios'
import LicensePlate from '@/components/cars/LicensePlate'

export default {
  data() {
    return {
      tableData: {
        results: [],
      },
      loading: true,
      search: '',
      serviceModalVisible: false,
      serviceDetails: null,
      serviceLoading: false,
      downloadingAttachments: {},
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
    }
  },

  methods: {
    getTypeLabel(contentType) {
      if (contentType.app_label === 'services') {
        return 'سرویس دوره‌ای'
      }
      return contentType.app_label
    },
    async updateApprovalStatus(id, approved) {
      try {
        await updateApproval.api(id, approved)
        // Update the local data
        const item = this.tableData.results.find((item) => item.id === id)
        if (item) {
          item.approved = approved
        }
        this.$message.success('وضعیت تایید با موفقیت به‌روزرسانی شد')
      } catch (error) {
        this.$message.error('خطا در به‌روزرسانی وضعیت تایید')
      }
    },
    async showServiceDetails(serviceId) {
      this.serviceModalVisible = true
      this.serviceLoading = true
      this.serviceDetails = null

      try {
        const response = await getAService.api(serviceId)
        this.serviceDetails = response
      } catch (error) {
        this.$message.error('خطا در بارگذاری جزئیات سرویس')
        this.serviceModalVisible = false
      } finally {
        this.serviceLoading = false
      }
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('fa-IR')
    },
    formatPrice(price) {
      if (!price) return '0'
      return new Intl.NumberFormat('fa-IR').format(price)
    },
    async downloadAttachment(attachmentId) {
      // Set loading state for this specific attachment
      this.$set(this.downloadingAttachments, attachmentId, true)

      try {
        const response = await axiosFactory({ type: 'blob' }).auth.get(
          `attachments/${attachmentId}/`
        )

        // Get the filename from the response headers or use a default
        const contentDisposition = response.headers['content-disposition']
        let filename = 'attachment'
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/)
          if (filenameMatch) {
            filename = filenameMatch[1]
          }
        }

        // Create blob and download
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.$message.success('پیوست با موفقیت دانلود شد')
      } catch (error) {
        console.error('Download error:', error)
        this.$message.error('خطا در دانلود پیوست')
      } finally {
        // Clear loading state for this specific attachment
        this.$set(this.downloadingAttachments, attachmentId, false)
      }
    },
  },
  mounted() {
    getApprovals.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })

    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  components: {
    LicensePlate,
  },
}
</script>

<style scoped>
.service-details {
  padding: 20px 0;
}

.detail-item {
  margin-bottom: 20px;
}

.detail-item label {
  display: block;
  font-weight: bold;
  color: #606266;
  margin-bottom: 8px;
  font-size: 14px;
}

.detail-item p {
  margin: 0;
  color: #303133;
  font-size: 14px;
  line-height: 1.5;
}

.text-center {
  text-align: center;
  padding: 40px 0;
}

.dialog-footer {
  text-align: left;
}
</style>
